import axios from "axios";
let Axios = axios.create({
  headers: {
    "content-type": "application/json;charset=UTF-8"
  }
});
// http request 拦截器
Axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
Axios.interceptors.response.use(
  response => {
    if (response.data.code && response.data.code != 0) {
        console.log(response)
    }
    return response.data;
  },
  //接口错误状态处理，也就是说无响应时的处理
  error => {
    return Promise.reject(error); // 返回接口返回的错误信息
  }
);

export default Axios;